import script from "./ClientArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientArea.vue?vue&type=script&setup=true&lang=js"

import "./ClientArea.vue?vue&type=style&index=0&id=409cc87f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409cc87f"]])

export default __exports__